import { process } from "@progress/kendo-data-query";
import {
  Grid,
  GridColumn as Column,
  GridDetailRow,
  GridToolbar,
  GridCell,
} from "@progress/kendo-react-grid";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  updateCarrierMasterChild,
  updateCarrierMasterParent,
  addCarrierMasterChild,
} from "./CarrierMasterPageService";
import CarrierMasterParentForm from "./CarrierMasterParentForm";
import { Input } from "@progress/kendo-react-inputs";
import "./CarrierMasterSearch.scss";

function CarrierMasterTable({ cmTableData, onSearchClickCM, currencyData }) {
  const [dataState, setDataState] = useState({
    sort: [{ field: "parentScac", dir: "asc" }],
    skip: 0,
    take: 10,
  });
  const [result, setResult] = useState(
    process(cmTableData["parent"], dataState)
  );
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(false);

  useEffect(() => {
    setResult(process(cmTableData["parent"], dataState));
  }, [cmTableData]);

  function expandChange(event) {
    event.dataItem.expanded = event.value;
    const carriedID = event.dataItem.carrier;
    //setResult({ ...result }); 
    setResult({ 
      ...result,
      data: [...result.data],
    });

    if (!event.value || event.dataItem.details) {
      return;
    }

    event.dataItem.details = cmTableData["child"].filter(
      (child) => child.carrier === carriedID
    );
    //setResult({ ...result }); 
    setResult({ 
      ...result,
      data: [...result.data],
    });
  }

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  const enterEdit = (item) => {
    console.log({ item });
    setOpenForm(true);
    setEditItem({ ...item });
  };

  const onDataStateChange = (event) => {
    setDataState(event.dataState);
    setResult(process(cmTableData["parent"], event.dataState));
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const handleSubmit = async (submitEvent) => {
    const result = await updateCarrierMasterParent({
      parent: [{ ...submitEvent }],
    });
    if (result[0]["message"] === "Success") {
      toast.success("Carrier Record updated successfully",{theme:"colored"});
    } else {
      toast.error(result[0]["message"]);
    }
    setOpenForm(false);
    onSearchClickCM({ text: "ALL", value: "all" });
  };

  const MyDetailComponent = (props) => {
    console.log({ props });

    return (
      <DetailComponent
        {...props}
        currencyData={currencyData}
        onSearchClickCM={onSearchClickCM}
      />
    );
  };

  return (
    <>
      <div className="tableStyle carrier-master-table">
        {cmTableData["parent"] && (
          <Grid
            ScrollMode="scrollable"
            style={{ height: "600px", width: 'auto'}} 
            data={result}
            detail={MyDetailComponent}
            expandField="expanded"
            onExpandChange={expandChange}
            pageable
            total={result.length}
            {...dataState}
            reorderable
            filterable
            onDataStateChange={onDataStateChange}
          >
            <Column
              cell={MyEditCommandCell}
              headerCell={() => <span></span>}
              filterable={false}
              width="50px"
            />
            <Column
              field="parentScac"
              width="100px"
              headerCell={() => (
                <span className="spanClass">
                  Parent SCAC <em className="emColor">*</em>
                </span>
              )}
            />
            <Column
              field="ctsiScac"
              width="100px"
              headerCell={() => (
                <span className="spanClass">
                  CTSI SCAC <em className="emColor">*</em>
                </span>
              )}
            />
            <Column
              field="cmEmail1"
              width="240px"
              headerCell={() => (
                <span className="spanClass">
                  CM email ID1 <em className="emColor">*</em>
                </span>
              )}
            />
            <Column
              field="cmPhNo1"
              width="150px"
              headerCell={() => (
                <span className="spanClass">
                  Phone No 1 <em className="emColor">*</em>
                </span>
              )}
            />
            <Column
              field="cmEmail2"
              width="240px"
              headerCell={() => (
                <span className="spanClass">
                  CM email ID2 <em className="emColor">*</em>
                </span>
              )}
            />
            <Column
              field="cmPhNo2"
              width="150px"
              headerCell={() => (
                <span className="spanClass">
                  Phone No 2 <em className="emColor">*</em>
                </span>
              )}
            />
            <Column
              field="carrierEmail1"
              width="240px"
              headerCell={() => (
                <span className="spanClass">
                  Carrier Email 1 <em className="emColor">*</em>
                </span>
              )}
            />
            <Column
              field="carrierPhNo1"
              width="150px"
              headerCell={() => (
                <span className="spanClass">
                  Carrier Phone 1 <em className="emColor">*</em>
                </span>
              )}
            />
            <Column
              field="carrierEmail2"
              width="240px"
              headerCell={() => (
                <span className="spanClass">
                  Carrier Email 2 <em className="emColor">*</em>
                </span>
              )}
            />
            <Column
              field="carrierPhNo2"
              width="150px"
              headerCell={() => (
                <span className="spanClass">
                  Carrier Phone 2 <em className="emColor">*</em>
                </span>
              )}
            />
          </Grid>
        )}
        {openForm && (
          <CarrierMasterParentForm
            cancelEdit={handleCancelEdit}
            onSubmit={handleSubmit}
            item={editItem}
          />
        )}
      </div>
      {/* <ToastContainer position="top-right" autoClose={5000} /> */}
    </>
  );
}

class DetailComponent extends GridDetailRow {
  render() {
    return (
      <ChildTable
        childTableData={this.props.dataItem.details}
        currencyData={this.props.currencyData}
        carrier={this.props.dataItem.carrier}
        parentScac={this.props.dataItem.parentScac}
        onSearchClickCM={this.props.onSearchClickCM}
      />
      
    );
  }
}

function ChildTable({
  childTableData,
  currencyData,
  carrier,
  parentScac,
  onSearchClickCM,
}) {
  const editField = "inEdit";
  const childTableDataCurrencyFiltered = checkForUndefined();
  const [data, setData] = useState(childTableDataCurrencyFiltered);
  const { ROLE_LIST } = JSON.parse(sessionStorage.getItem("profile"));
  const { MDADMIN, MDVIEWER } = ROLE_LIST;
  const hideButtons = MDADMIN === "False" && MDVIEWER === "True" ? true : false;

  useEffect(() => {
    const parentScacExistInChild = childTableDataCurrencyFiltered.findIndex(
      (data) => data["childScac"] === parentScac
    );

    if (
      childTableDataCurrencyFiltered.length === 0 ||
      parentScacExistInChild === -1
    ) {
      addNew(parentScac);
    }
  }, []);

  function checkForUndefined() {
    let data = childTableData.map((_data) =>
      typeof _data["currency"] === "undefined"
        ? { ..._data, currency: [] }
        : _data
    );
    return data;
  }

  function enterEditFunc(dataItem) {
    const tempData = data.map((item) =>
      item.childScac === dataItem.childScac
        ? { ...item, inEdit: true, recordType: "E" }
        : item
    );

    setData(tempData);
  }

  async function add(item) {
    const child = [
      {
        childScac: item["childScac"],
        Currency: item["currency"].join(),
        carrier: item["carrier"],
      },
    ];

    const result = await addCarrierMasterChild({ child });

    if (result[0]["msgType"] === "S") {
      const tempData = data.map((_item) =>
        _item.id === item.id ? { ...item, inEdit: false } : _item
      );
      setData(tempData);
      onSearchClickCM({ text: "ALL", value: "all" });
      toast.success("Record updated successfully",{theme:"colored"});
    } else {
      const tempData = [...data];
      tempData.splice(0, 1);
      setData(tempData);
      toast.error("Error in adding record");
      toast.error(`${result[0]["message"]}`,{theme:"colored"});
    }
  }

  function discard(dataItem) {
    const tempData = [...data];
    tempData.splice(0, 1);
    setData(tempData);
  }

  async function update(item) {
    const child = [
      {
        ...item,
        Currency: item["currency"].join(),
        inEdit: false,
      },
    ];
    const result = await updateCarrierMasterChild({ child });

    const tempData = data.map((_item) =>
      _item.id === item.id ? child[0] : _item
    );

    setData(tempData);
    onSearchClickCM({ text: "ALL", value: "all" });
  }

  function cancel(dataItem) {
    const originalItem = childTableDataCurrencyFiltered.find(
      (p) => p.id === dataItem.id
    );
    const tempData = data.map((item) =>
      item.id === originalItem.id ? originalItem : item
    );

    setData(tempData);
  }

  const CommandCell = (props) => (
    <MyCommandCell
      {...props}
      edit={enterEditFunc}
      add={add}
      discard={discard}
      update={update}
      cancel={cancel}
      editField={editField}
    />
  );

  const addNew = (scac = "") => {
    const newDataItem = {
      inEdit: true,
      childScac: scac,
      currency: [],
      recordType: "A",
      id: Math.floor(Math.random() * 10000000),
      carrier: carrier,
    };
    setData([newDataItem, ...data]);
  };

  const itemChange = (event) => {
    const tempData = data.map((item) =>
      item.childScac === event.dataItem.childScac
        ? { ...item, [event.field]: event.value }
        : item
    );

    setData(tempData);
  };

  const myMultiSelectCell = (props) => (
    <MultiSelectCell {...props} currencyData={currencyData} />
  );

  const myScacChildCell = (props) => <ScacChildCell {...props} />;

  return (
    <>
      <Grid data={data} editField={editField} onItemChange={itemChange}  style = {{width:"1380px"}}>
        <GridToolbar>
          <div>
            {!hideButtons && (
              <button
                className="btn k-button k-button-icontext"
                style={{ width: "130px" }}
                onClick={() => {
                  addNew();
                }}
              >
                Add Child SCAC
              </button>
            )}
          </div>
        </GridToolbar>
        <Column
          cell={CommandCell}
          headerCell={() => <span>Update</span>}
          filterable={false}
          width = "450px"
        />
        <Column field="childScac" title="Child SCAC" cell={myScacChildCell} width = "450px"/>
        <Column field="currency" title="Currency" cell={myMultiSelectCell} width = "450px"/>
      </Grid>
      {/* <div><pre>{JSON.stringify(data, null, 2)}</pre></div> */}
    </>
  );
}

class ScacChildCell extends (GridCell, React.Component) {
  state = {
    input: null,
  };

  handleChange(e) {
    this.setState({ input: e.target.value });
  }

  handleBlur(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.input,
    });
    this.setState({ input: "" });
  }

  render() {
    const value = this.props.dataItem[this.props.field];

    if (
      !this.props.dataItem.inEdit ||
      (this.props.dataItem.childScac !== "" &&
        this.props.dataItem.currency.length !== 0)
    ) {
      return (
        <td>
          {" "}
          {value === null
            ? ""
            : typeof this.props.dataItem[this.props.field] === "string"
            ? this.props.dataItem[this.props.field]
            : this.props.dataItem[this.props.field].toString()}
        </td>
      );
    } else {
      return (
        <td>
          <Input
            onChange={this.handleChange.bind(this)}
            onBlur={(e) => {
              this.handleBlur(e);
            }}
            value={
              this.state.input === null
                ? this.props.dataItem["childScac"]
                : this.state.input
            }
          />
        </td>
      );
    }
  }
}

class MultiSelectCell extends (GridCell, React.Component) {
  handleChange(e) {
    console.log(e);
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
  }

  render() {
    const value = this.props.dataItem[this.props.field];

    if (!this.props.dataItem.inEdit) {
      return (
        <td>
          {" "}
          {value === null
            ? ""
            : typeof this.props.dataItem[this.props.field] === "string"
            ? this.props.dataItem[this.props.field]
            : this.props.dataItem[this.props.field].toString()}
        </td>
      );
    }

    return (
      <td>
        <MultiSelect
          data={this.props.currencyData}
          onChange={this.handleChange.bind(this)}
          value={
            typeof this.props.dataItem["currency"] === "string"
              ? this.props.dataItem["currency"].split(",")
              : this.props.dataItem["currency"]
          }
        />
        {/* 
                  valueField="value"
                  textField="text" */}
      </td>
    );
  }
}

const EditCommandCell = (props) => {
  const { ROLE_LIST } = JSON.parse(sessionStorage.getItem("profile"));
  const { MDADMIN, MDVIEWER } = ROLE_LIST;
  const hideEdit = MDADMIN === "False" && MDVIEWER === "True" ? true : false;

  return (
    <td>
      {!hideEdit ? (
        <span
          className="k-icon k-i-pencil"
          style={{ cursor: "pointer" }}
          onClick={() => props.enterEdit(props.dataItem)}
        >
          {" "}
        </span>
      ) : (
        <></>
      )}
     
    </td>
  );
};

export const MyCommandCell = (props) => {
  const { dataItem } = props;
  const inEdit = dataItem[props.editField];
  const isNewItem = dataItem.recordType === "A";
  const { ROLE_LIST } = JSON.parse(sessionStorage.getItem("profile"));
  const { MDADMIN, MDVIEWER } = ROLE_LIST;
  const hideButtons = MDADMIN === "False" && MDVIEWER === "True" ? true : false;

  return inEdit ? (
    <td className="k-command-cell">
      
      {!hideButtons && (
        <>
          <button
            className="btn k-button k-button-icontext k-grid-save-command"
            onClick={() =>
              isNewItem ? props.add(dataItem) : props.update(dataItem)
            }
          >
            {isNewItem ? "Update" : "Update"}
          </button>
          <button
            className="btn k-button k-button-icontext rejectbtn @k-grid-cancel-command"
            onClick={() =>
              isNewItem ? props.discard(dataItem) : props.cancel(dataItem)
            }
          >
            {isNewItem ? "Cancel" : "Cancel"}
          </button>
        </>
      )}
      
    </td>
  ) : (
    !hideButtons && (
      <td className="k-command-cell">
        <button
          className="k-button k-grid-edit-command"
          onClick={() => props.edit(dataItem)}
        >
          Update
        </button>
      </td>
    )
  );
};

export default CarrierMasterTable;
